module.exports = __webpack_public_path__ + "static/media/bg_7.c675aedb.jpg";